import { getResponseData } from '@/helpers/mocks';
import { HttpResponse, delay } from 'msw';

const RESPONSE = {
  default: {
    response: {
      createdAt: 1701115461239,
      object: 'counselors',
      success: true,
      counselors: [
        {
          id: '1',
          name: 'יועץ קרדיט פרו',
          email: 'service@creditpro.co.il',
          title: 'יועץ קרדיט פרו',
        },
      ],
    },
    status: 200,
  },

  error: {
    response: {
      createdAt: 1701115461239,
      object: 'counselors',
      success: false,
      counselors: [],
    },
    status: 500,
  },
};

const counselorHandler = async () => {
  const { response, status } = getResponseData(RESPONSE);
  await delay(1000);
  return HttpResponse.json(response, status);
};

export {
  counselorHandler,
};
